import React, { useCallback, useRef } from 'react'
import "./MessagesListTransactionReport.css"
import { useSelector } from 'react-redux'
import { RootState } from '../../../../../redux/store/store'
import { Message } from '../../../../../utils/dbModels'
import MessageTransactionReport from './MessageTransactionReport/MessageTransactionReport'
import InputChatTransactionReport from './InputChatTransactionReport/InputChatTransactionReport'

type MessagesListProps = {

}

const MessagesListTransactionReport = ({  }: MessagesListProps) => {
    //console.log(" ")
    //console.log("type", type)
    const messages: Message[] = []
    const inputRef = useRef<{ resetInputPersonInvolved: () => void, resetInputRequestBy: () => void }>(null)
    const userRequestReportId = useSelector((state: RootState) => state.transactionReports.transactionReport.id)

    /*
    const supportId = useSelector((state: RootState) => state.auth.user.id)

    const indexLastMessageSupport = useMemo(() => { 
        let currentIndex = -1
        for(let i=0; i<messages.length; i++){
            if(messages[i].userID !== requestById && messages[i].userID !== personInvolvedId){
                currentIndex = i
            }
        }
        return currentIndex
    }, [messages])

        //console.log("indexLastMessageSupport", indexLastMessageSupport)
*/

    const onPress = useCallback(
      () => {
        
      },
      [],
    )
    

    return (
        <div className="flex-1 athens-gray-bg con-messages-tran-report flex flex-d-column  p-12">
            <p className="fs-18 fw-600">Chat</p>
            <div className="flex-1 p-relative">
                <div className={`p-absolute aux-scroll`}>
                    <div className="message-list">
                        {
                            messages.map((message, index) => {
                                return(
                                    <MessageTransactionReport 
                                        checkView={message.viewed} 
                                        userId={userRequestReportId}
                                        message={message} 
                                        key={index} 
                                        isFirstGroupMessage={message.isFirstGroupMessage}
                                        userImgUrl={""}
                                    />
                                )
                            })
                        }
                    </div>
                </div>
            </div>

            <InputChatTransactionReport ref={inputRef} onSendPress={onPress} />
        </div>

    )
}

/*
,
    (prevProps: MessagesListProps, nextProps: MessagesListProps) => {
        return true
    }
*/

export default React.memo( MessagesListTransactionReport )